import { useAuth } from "../hooks/useAuth";
import DashboardLayout from "../components/layout/DashboardLayout";
import PublicLayout from "../components/layout/PublicLayout";
import Support from "./Support";

export default function SupportWrapper() {
    const { isAuthenticated } = useAuth();
    const token = localStorage.getItem("token");
    const loggedIn = isAuthenticated || !!token;

    if (loggedIn) {
        return (
            <DashboardLayout>
                <Support />
            </DashboardLayout>
        );
    }

    return (
        <PublicLayout>
            <Support />
        </PublicLayout>
    );
}
